import lodash from 'lodash'
import Base from '../base.store'

const baseUrl = '/api/v1/master/faqs'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        notiNews(context, { id, config }) {
            return base.request.post(`${baseUrl}/_news_noti`, JSON.stringify(id), { ...config });
        },
    },
    mutations: {
        ...base.mutations
    },
}
